import { Component, Input, OnInit } from '@angular/core';
import { DataSourceItemsService } from '../../../../data-source/data-source-items/services/data-source-items.service';
import { IStatDefinition } from '../interfaces/stat-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss'],
})
export class StatComponent implements OnInit {
  constructor(private dataService: DataSourceItemsService) {}

  statValue;
  isLoading = true;

  @Input() statDefinition: IStatDefinition;

  ngOnInit() {
    this.fetchStat();
  }

  get hasDelta() {
    return typeof this.statDefinition?.deltaPercentage === 'number';
  }

  get isDeltaUp() {
    return (this.statDefinition?.deltaPercentage || 0) >= 0;
  }

  private fetchStat() {
    if (typeof this.statDefinition?.staticValue === 'number') {
      this.statValue = this.statDefinition.staticValue;
      this.isLoading = false;
      return;
    }

    if (!this.statDefinition?.recipe) {
      this.statValue = 0;
      this.isLoading = false;
      return;
    }

    this.dataService
      .getAggregated(this.statDefinition.recipe)
      .then((response) => {
        response = (response as Array<any>).map((item) => {
          return { name: item._id, value: item.value };
        });

        if (response[0]) {
          this.statValue = response[0].value;
        } else {
          this.statValue = 0;
        }
      })
      .catch(() => {
        this.statValue = 0;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
